import(/* webpackMode: "eager", webpackExports: ["BlogPostView"] */ "/vercel/path0/frontend_next/src/components/views/BlogPostView.tsx");
